import React, { useState, useEffect, useRef } from "react";
import { contains_heb } from "utils/hebrewOrArabicText.js";
import ModernDropdown from "../../../Elements/ModernDropdown/ModernDropdown.js";

const FormSelectComponent = ({
  field,
  buttonsColor,
  handleChangeSimpleInput,
  prevCookie,
  urlParameter,
}) => {
  const selectRef = useRef();
  const list = field.fields.options;
  const [titleDropDown, setTitleDropDown] = useState(
    urlParameter ? urlParameter : prevCookie ? prevCookie : null
  );
  const [showDropDownExternal, setShowDropDownExternal] = useState(false);
  const [selectListValue, setSelectListValue] = useState(null);
  const handleChange = (e, itemKey) => {
    handleChangeSimpleInput(field.fields.options[itemKey]);
    setSelectListValue(field.fields.options[itemKey]);
    setTitleDropDown(field.fields.options[itemKey]);
  };
  const [isOpen, setIsOpen] = useState(false);
  const isDropDownOpen = (state) => {
    setIsOpen(state);
  };

  const openDropdown = () => {
    setShowDropDownExternal((prev) => !prev);
  };

  useEffect(() => {
    if (isOpen) {
      //scroll to end on selectRef
      selectRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [isOpen]);

  const enterButtonFunction = (e) => {
    if (e.key === "Enter") {
      openDropdown();
    }
  };
  return (
    <div
      ref={selectRef}
      className={`select input ${contains_heb(field.fields.label)}`}
    >
      <div
        tabIndex={0}
        onKeyDown={(e) => enterButtonFunction(e)}
        onClick={() => openDropdown()}
        className={`select-title ${
          !isOpen && !selectListValue ? "select-blank" : ""
        }`}
      >
        <span>{field.fields.label}</span>
      </div>
      <ModernDropdown
        isDropDownOpen={isDropDownOpen}
        title={titleDropDown}
        showDropDownExternal={showDropDownExternal}
        setShowDropDownExternal={setShowDropDownExternal}
        handleChange={handleChange}
        selectList={list}
        defaultValue={
          urlParameter ? urlParameter : prevCookie ? prevCookie : null
        }
      >
        <div className="">
          <i
            //style={{ color: "#" + buttonsColor }}
            className="fa fa-caret-down"
            aria-hidden="true"
          ></i>
        </div>
      </ModernDropdown>
    </div>
  );
};

export default FormSelectComponent;
